import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { map, Observable } from 'rxjs';
import { BackofficeGroupsModel } from '../../../helpers/objects/dto/backoffice-groups/backoffice-groups-model/backoffice-groups-model';
import { BackofficeGroupsResponseModel } from '../../../helpers/objects/response/backoffice-groups/backoffice-groups-response-model';
import { BackofficeCreateGroupModel } from '../../../helpers/objects/dto/backoffice-groups/backoffice-create-group/backoffice-create-group-model';
import { BoGroupsListRequestModel } from '../../../helpers/objects/request/backoffice-groups/bo-groups-list-request-model/bo-groups-list-request-model';

@Injectable({
  providedIn: 'root'
})
export class BackofficeGroupsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;
  }

  getGroups(filter?: BoGroupsListRequestModel): Observable<BackofficeGroupsResponseModel> {
    const httpParams: HttpParams = new HttpParams({ fromObject: filter as any });
    return this.http
      .get(this.appConfig.api + 'backoffice/groups/' + this.appConfig.apiPartnershipId, { params: httpParams })
      .pipe(map((response: any) => response.body as BackofficeGroupsResponseModel));
  }

  createGroup(group: BackofficeCreateGroupModel): Observable<any> {
    return this.http.post(this.appConfig.api + 'backoffice/groups/' + this.appConfig.apiPartnershipId, {
      name: group?.name,
      agents: group?.agents
    });
  }

  editGroup(editGroup: BackofficeGroupsModel): Observable<any> {
    return this.http.put(this.appConfig.api + 'backoffice/groups/' + this.appConfig.apiPartnershipId, {
      groupId: editGroup.groupId,
      name: editGroup.name,
      active: editGroup.active
    });
  }

  getGroupDetails(groupId: any): Observable<any> {
    return this.http.get(this.appConfig.api + 'backoffice/groups/' + this.appConfig.apiPartnershipId + '/' + groupId).pipe(
      map((response) => {
        return response;
      })
    );
  }

  editAgentsinGroup(id: any, editAgentsInGroup: any): Observable<any> {
    return this.http.post(this.appConfig.api + 'backoffice/groups-agents/' + this.appConfig.apiPartnershipId, {
      agentsToGroup: {
        groupId: id,
        agentsCode: editAgentsInGroup
      }
    });
  }

  editGroupsinAgent(body: any): Observable<any> {
    return this.http.post(this.appConfig.api + 'backoffice/groups-agents/' + this.appConfig.apiPartnershipId, body);
  }

  getUserGroup(groupId: any): Observable<any> {
    return this.http.get(this.appConfig.api + 'backoffice/groups-agents/' + this.appConfig.apiPartnershipId + '/' + groupId).pipe(
      map((response) => {
        return response;
      })
    );
  }
}
